/**
 * Created by jacob.mendt@pikobytes.de on 08.11.20.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import { Box } from '@mui/material';
import React from 'react';

interface ContentSectionProps {
    children?: any;
    className?: string;
    color?: string;
}

export default function ContentSection(props: ContentSectionProps) {
    const { className = '', children, color = '#fff' } = props;
    return (
        <Box
            className={className}
            sx={{
                backgroundColor: color,
                display: 'flex',
                margin: 0,
                flexGrow: 1,
                flexDirection: 'column',
            }}
        >
            {children}
        </Box>
    );
}
